import {
    ICreateAllDigitalDeliveries,
  IDigitalDeliveryForm,
  IDigitalDeliveryIdentificators,
  IDigitalDeliveryMutation,
} from 'services/digital-delivery/types';
//

export const digitalDeliveryFormToQuery = (
  form: IDigitalDeliveryForm,
  deliveryIdentification: IDigitalDeliveryIdentificators
): IDigitalDeliveryMutation => ({
  ...deliveryIdentification,
  version: form.version,
  included: form.included.map(d => ({
    ...d,
    publishTime: `${d.publishTime}:00`.slice(0, 8),
  })),
  excluded: form.excluded.map(d => ({
    ...d,
    publishTime: `${d.publishTime}:00`.slice(0, 8),
  })),
  priority: false,
});
export const digitalDeliveryAllFormToQuery = (
  form: IDigitalDeliveryForm,
  productId: string,
): ICreateAllDigitalDeliveries => ({
  productId,
  included: form.included.map(d => ({
    ...d,
    publishTime: `${d.publishTime}:00`.slice(0, 8),
  })),
  excluded: form.excluded.map(d => ({
    ...d,
    publishTime: `${d.publishTime}:00`.slice(0, 8),
  })),
  priority: false,
});
